import { useContext } from "react";
import NavigationContext from "../context/NavigationContext";

const useNav = () => {
    return useContext(NavigationContext) as NavigationContext
}

export default useNav;